
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Rutgeerts',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GD/Rutgeerts.vue